'use es6';

import { List } from 'immutable';
import { TrackingStatusCodes } from 'AdsUI/lib/Constants';
import TrackingStatusRecord from 'AdsUI/records/reporting/TrackingStatusRecord';
import TrackingErrorRecord, { IGNORABLE_TRACKING_ERRORS } from 'AdsUI/records/reporting/TrackingErrorRecord';

const getCode = (trackingStatus, statuses) => {
  if (trackingStatus.untracked.length > 0 && statuses.size === 0) {
    // We need to filter out this state; this means that there were tracking
    // errors but they were all of the type that we should ignore. (for example, a
    // completed ad set, or due to a deleted ad inside an ad group)
    //
    // Without this, we can't distinguish that case from "tracking pending".
    return TrackingStatusCodes.TRACKED;
  }

  return trackingStatus.code;
};

const parse = trackingStatus => {
  if (!trackingStatus || trackingStatus.code === TrackingStatusCodes.TRACKED) {
    return TrackingStatusRecord();
  } else {
    const statuses = List(trackingStatus.untracked).flatMap(({
      errors
    }) => errors.filter(({
      reason
    }) => !IGNORABLE_TRACKING_ERRORS.includes(reason)).map(error => new TrackingErrorRecord(error)));
    const code = getCode(trackingStatus, statuses);
    const lastAttempted = trackingStatus.untracked.map(status => status.lastAttempted).sort().reverse()[0];
    return new TrackingStatusRecord({
      code,
      statuses,
      lastAttempted
    });
  }
};

export default {
  parse
};